module.exports = function() {
    return {
        restrict: 'AE',
        scope: {
            'scrollTo': '<',
            'duration': '<?'
        },
        link: function($scope, $element) {
            var duration = $scope.duration || 250;

            $element.on('click.scrollTo', function() {
                var $to = $($scope.scrollTo);

                if ($to && $to.length > 0) {
                    $('html,body').animate({
                        scrollTop: $to.offset().top
                    }, duration);
                } else {
                    console.error('Cannot found element ' + $scope.scrollTo);
                }
            });

            $scope.$on('destroy', function() {
                $element.off('click.scrollTo');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./assets/app/scrollTo.directive.js
// module id = 7
// module chunks = 0